import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import toast from "react-hot-toast";

import CustomActionButton from '../../../common/CustomActionButton';
import { RemoveSuperUserToList } from '../../../redux/superUser/actions';
import { apiCallV2 } from '../../../utils/api'

const EditUser = (props) => {
    const { user, setOpenEditSuperUser } = props;
    const [buttonStatus, setButtonStatus] = useState('action')
    const [selectedOption, setSelectedOption] = useState("");

    const handleConfirm = async () => {
        setButtonStatus('loading')

        if (selectedOption == "expire") {
            const res = await apiCallV2("POST", "admin/super-user/expire-subscription", user, localStorage.getItem("access-token"));
            if (res.data.status === 200) {
                props.RemoveSuperUserToList(user);

                toast.success('Removed!')
                setOpenEditSuperUser(false)
                setButtonStatus('saved')
            }
            if (res.data.status === 500) {
                toast.error(res.data.message)
                setButtonStatus('action')
            }
        } else if (selectedOption == "remove") {
            const res = await apiCallV2("POST", "admin/super-user/remove-super-user", user, localStorage.getItem("access-token"));
            if (res.data.status === 200) {
                props.RemoveSuperUserToList(user);

                toast.success('Removed!')
                setOpenEditSuperUser(false)
                setButtonStatus('saved')
            }
            if (res.data.status === 500) {
                toast.error(res.data.message)
                setButtonStatus('action')
            }
        }

    }

    return (
        <div id="edit-super-user-form">
            <Box sx={{ mb: '30px' }}>
                <div id="esuf-header">
                    <p>
                        {
                            user?.firstname
                                ? (user?.firstname + " " + user?.lastname + " " + (user?.dob ? ` - DOB: ${user?.dob}` : ""))
                                : '"No Super User added"'
                        }
                    </p>
                    <p>{user?.name || "NO COMPANY"}</p>
                </div>

                <div>
                    <div id="option-card-list">
                        <div id="option-card" onClick={() => {
                            setSelectedOption(selectedOption == "remove" ? "" : 'remove');
                        }}>
                            <div class={"op-indicator " + ((selectedOption == "remove" || selectedOption == "expire") ? "selected" : "")}></div>
                            <h5>Remove Super User Status</h5>
                        </div>

                        <div id="option-card" onClick={() => {
                            setSelectedOption(selectedOption == "expire" ? "" : 'expire');
                        }}>
                            <div class={"op-indicator " + (selectedOption == "expire" ? "selected" : "")}></div>
                            <h5>Expire Subscription(s)</h5>
                        </div>
                    </div>

                    <div className='edit-su-action'>
                        <CustomActionButton action={handleConfirm}>UPDATE</CustomActionButton>
                    </div>

                </div>
            </Box>
        </div>
    );
};

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    RemoveSuperUserToList,
})(EditUser);